<template>
  <nx-sheets-fixed
    v-if="shouldRender"
    :class="[
      bem(),
      fullScreen ? bem('fullScreen') : '',
      disableContentPd ? bem('no-content-pd') : '',
      maxHeightFill ? 'max-height-fill' : '',
      maxHeightPaddingFill ? 'max-height-padding' : '',
      minHeightFill ? 'min-height-fill' : '',
      hideTitle ? 'hide-title' : ''
    ]"
    :value="show"
    :showCancelIcon="closeShow"
    :leftIcon="backShow ? require(`@/assets/img/common/icon-arrow-left.png`) : ''"
    v-backFn="backFnDisable ? {} : { show: show, closeFn: 'closeFn' }"
    :backHistoryNum="backHistoryNum"
    :historyHasNativeBack="historyHasNativeBack"
    :sheetsTitle="title"
    @change="$emit('input', $event.target.value)"
    @hide="closeFn"
    @leftIconClick="back"
    id="vPopup"
    role="dialog"
    aria-modal="true"
    aria-hidden="false"
    :ariaPopupLabel="ariaPopupLabel"
    :isWebviewFull="true"
    :multiplePopup="true"
    :addLock="false"
  >
    <template slot="left" v-if="footerShow || $slots.left">
      <slot name="left" />
    </template>
    <div :class="[bem('content'), footerShow || $slots.footer ? 'contain-footer-pd' : '']">
      <slot />
    </div>
    <template slot="bottom" v-if="footerShow || $slots.footer">
      <div v-if="$slots.footer" :class="[bem('footer')]">
        <slot name="footer" />
      </div>
      <div :class="[bem('footer')]" v-else>
        <v-button type="frame-plus" position="center" @click="footerClick">
          {{ footerText }}
        </v-button>
      </div>
    </template>
  </nx-sheets-fixed>
</template>

<script>
import { SheetsFixed } from '@vivo/vos-ui'
import env from 'utils/clientEnv'
import create from '../create'
import ospopup from '../mixins/ospopup/index.js'

export default create({
  name: 'os-popup',
  mixins: [ospopup],
  model: {
    prop: 'show',
    event: 'change'
  },
  components: {
    [SheetsFixed.name]: SheetsFixed
  },
  props: {
    position: {
      type: String,
      default: 'bottom'
    },
    show: {
      type: Boolean,
      default: false
    },
    // 弹窗高度占全屏的百分比
    height: {
      type: String,
      default: ''
    },
    title: String,
    // 底部按钮文案
    footerText: {
      type: String,
      default: '确定'
    },
    ariaPopupLabel: String,
    fullScreen: {
      // 是否全屏， true是全屏 false 是半屏
      type: Boolean,
      default: false
    },
    closeShow: {
      // 是否展示title关闭按钮
      type: Boolean,
      default: true
    },
    backShow: {
      // 是否展示返回按钮
      type: Boolean,
      default: false
    },
    footerShow: {
      // 是否展示底部
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: true
    },
    borderBottom: {
      // 底部是否有上边框
      type: Boolean,
      default: false
    },
    // 弹窗添加时所处的容器
    container: {
      type: String,
      default: ''
    },
    // 弹窗不增加返回拦截
    backFnDisable: {
      type: Boolean,
      default: false
    },
    // content原组件有padding
    disableContentPd: {
      type: Boolean,
      default: false
    },
    // 内部元素用最大高度填充
    maxHeightFill: {
      type: Boolean,
      default: false
    },
    // 内部元素用最大高度填充-paddding
    maxHeightPaddingFill: {
      type: Boolean,
      default: false
    },
    minHeightFill: {
      type: Boolean,
      default: true
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    backHistoryNum: {
      type: Number,
      default: 1
    },
    historyHasNativeBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {
    show: {
      handler(val, old) {
        // 解决IOS下-webkit-overflow-scrolling导致z-index失效的问题
        if (env.isIOS) {
          let type = val ? 'auto' : 'touch'
          document.querySelector('.v-page__container>.container') &&
            document
              .querySelector('.v-page__container>.container')
              .setAttribute('style', '-webkit-overflow-scrolling: ' + type)
        }
      }
    }
  },
  methods: {
    closeFn() {
      if (this.show) {
        this.$emit('close')
      }
    },
    back() {
      this.$emit('back')
    },
    footerClick() {
      this.$emit('footerClick')
    },
    focusEl(ref) {
      this.$refs?.[ref]?.focus()
    }
  }
})
</script>
<style lang="scss" scoped src="./index.scss"></style>
